// Hacky wrapper to ensure the context is available to the dialog's contents.
// Since context props must be explicitly defined, for now this only forwards the
// react-dnd dragDropManager, but more may be added in the future if needed.
import React from 'react'
import T from 'prop-types'

export default class ReactContextForwarder extends React.Component {
  static displayName = 'ReactContextForwarder'

  static propTypes = {
    context: T.any,
    children: T.node
  }

  static childContextTypes = {
    dragDropManager: T.object,
    onModalDialogOpened: T.func,
    onModalDialogClosed: T.func,
    store: T.any // Redux store
  }

  getChildContext() {
    return this.props.context
  }

  render() {
    return this.props.children
  }
}
